module.exports = __webpack_public_path__ + "static/media/edward-cisneros-415601-unsplash.2b9d6456.jpg";